module.exports = __webpack_public_path__ + "static/img/hx_img.4c32489.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hx_img.png
// module id = tntB
// module chunks = 1